// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import "./pdf.css";

// export const PdfTemplate = async (data, setbutLoad) => {
//   console.log("data", data);
//   // console.log("setbutLoad", setbutLoad);
//   // Create a new window
//   const printWindow = window.open("", "_blank");

//   // Check if the new window was successfully created
//   if (!printWindow) {
//     console.error("Failed to open new window. Check your popup settings.");
//     return;
//   }

//   const content = document.createElement("div");
//   content.style.backgroundColor = "#f5f5f5";
//   content.style.padding = "20px";
//   content.style.width = "80%";
//   content.style.margin = "0 auto";

//   content.innerHTML = `
//     <div class="outer-pdf">
//       <div class="pdf-border-container">
//         <div class="content">
//           <div class="d-flex justify-content-between align-items-center">
//             <img src="${data.logo}" style="width: 130px;" alt="Logo" />
//             <div class="avatar-pdf">
//               <img src="${data.avatar}" alt="Avatar" />
//             </div>
//           </div>
//           <div class="pdf-txt-cntnt mb-3">
//             <div class="text-center pdf">
//               <h1>
//                 VIBE INSURANCE BROKING AND ADVISORY <br />
//                 SERVICE PRIVATE LIMITED
//               </h1>
//               <p class="mb-2">Point Of Sale</p>
//               <p>Training Certificate</p>
//             </div>
//             <div class="d-flex justify-content-between align-items-center mt-4 pdf-reg">
//               <p>Registration No. ${data.registrationNo}</p>
//               <p>Date: ${data.date}</p>
//             </div>
//           </div>
//           <div class="certify-content">
//             This is to certify that <b>Mr./Ms. ${data.name}</b>
//             [Aadharno. <b>${data.aadharNo}</b> | PAN No: <b>${data.panNo}</b>] has
//             successfully completed the prescribed training on <b>${data.trainingDate}</b>
//             specified for Point of Sales Person examination conducted by Vibe Insurance
//             Broking and Advisory Service Pvt Ltd under the Guidelines of IRDAI
//             (Ref No. IRDAI/DB1027/2023 dated 04.07.2023)
//           </div>
//           <br />
//           <br />
//           <div class="pdf-txt-cntnt">
//             <div class="d-flex justify-content-between align-items-center">
//               <div class="text-center">
//                 <img src="${data.sign}" style="width: 100px;" alt="Signature" />
//                 <div class="sign-pdf">Principal officer</div>
//                 <div>${data.principalOfficer}</div>
//               </div>
//               <div class="text-center">
//                 <img src="${data.sign}" style="width: 100px;" alt="Signature" />
//                 <div class="sign-pdf">Technical Head</div>
//                 <div>${data.technicalHead}</div>
//               </div>
//             </div>
//           </div>
//           <br />
//           <br />
//           <div class="footer-pdf">${data.address}</div>
//         </div>
//       </div>
//     </div>
//   `;
//   printWindow.document.open();
//   printWindow.document.write(content.innerHTML);
//   printWindow.document.close();
//   // Append the content to the body temporarily for rendering
//   document.body.appendChild(content);

//   try {
//     const images = content.getElementsByTagName("img");
//     await Promise.all(
//       Array.from(images).map((img) => {
//         return new Promise((resolve, reject) => {
//           img.onload = resolve;
//           img.onerror = reject;
//         });
//       })
//     );

//     const canvas = await html2canvas(content, {
//       scale: 3,
//       useCORS: true,
//       // logging: true,
//     });
//     const imgData = canvas.toDataURL("image/png");

//     // Create a jsPDF instance
//     const pdf = new jsPDF({
//       orientation: "landscape",
//       unit: "pt",
//       format: "a4",
//       compress: true,
//     });

//     // Add the captured image to the PDF
//     const imgWidth = pdf.internal.pageSize.getWidth();
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;
//     pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

//     pdf.save("vibe_posp_certificate.pdf");
//     setbutLoad(false);
//   } catch (error) {
//     console.error("Error generating PDF:", error);
//   } finally {
//     // Clean up the content from the document
//     document.body.removeChild(content);
//   }
// };

// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
export const PdfTemplate = async (data, setbutLoad) => {
  console.log("data", data);
  setbutLoad(false);
  const printWindow = window.open("", "_blank");

  if (!printWindow) {
    setbutLoad(false);
    console.error("Failed to open new window. Check your popup settings.");
    return;
  }

  const contentHtml = `
    <html>
      <head>
        <style>
          body {
            -webkit-print-color-adjust:exact !important;
            print-color-adjust:exact !important;
            background-color: #f5f5f5;
            padding: 0;
            margin: 0;
            font: normal 125% / 1.4 "Open Sans", "Helvetica Neue Light", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
          }
          .outer-pdf {
             border: 12px solid #fff;
          }
          .pdf-border-container {
            background: linear-gradient(
              90deg,
              rgba(9, 9, 121, 1) 50%,
              rgba(0, 212, 255, 1) 100%
            );
           padding: 12px;
           border-radius: 8px;
          }
          .content {
            background: white;
            padding: 10px 20px;
            border-radius: 6px;
            position: relative;
          }
          .pdf h1 {
            font-size: 30px;
            font-weight: 700 !important;
            color: #076ab4;
            margin-top: 0;
            margin-bottom: 4px;
          }
          .avatar-pdf img {
            height: 100px;
            width: 100px;
            padding: 1px;
            border-radius: 50px;
            border: 0.5px solid rgb(192 192 192 / 12%);
            object-fit: contain;
            overflow: hidden;
          }
          .pdf p:first-of-type {
            font-size: 25px;
            font-weight: 700;
            color: #ff5733;
            margin: 0px 0 8px;
          }
          .pdf p:nth-of-type(2) {
            font-size: 26px;
            font-weight: 700;
            color: #076ab4;
            margin: 4px 0px 0;
          }
          .pdf-reg p {
            font-weight: 700;
            font-size: 16px;
          }
          .pdf-reg p {
            font-weight: 700;
            font-size: 16px;
          }
          .certify-content {
            font-size: 16px;
            text-align: justify !important;
           }
          .d-flex {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .pdf-txt-cntnt, .certify-content, .footer-pdf,h1,p {
            margin-top: 16px;
            text-align: center
          }
          .avatar-pdf img, .pdf-border-container img {
            max-width: 100px;
          }
          .sign-pdf {
            margin-top: 10px;
            font-weight: 700;
            font-size: 16px;
          }
          .pdf-txt-cntnt {
            margin: 0px 0px 10px;
          }
          .off-name {
            font-size: 14px;
          }
          .footer-pdf {
            font-size: 14px;
            text-align: center;
            margin: 0 auto;
            padding: 8px 0;
            background: #0000000d;
          }
        </style>
      </head>
      <body>
        <div class="outer-pdf">
          <div class="pdf-border-container">
            <div class="content">
              <div class="d-flex justify-content-between align-items-center">
                <img src="${data.logo}" style="width: 130px;" alt="Logo" />
                <div class="avatar-pdf">
                  <img src="${data.avatar}" alt="Avatar" />
                </div>
              </div>
              <div class="pdf-txt-cntnt mb-3">
                <div class="text-center pdf">
                  <h1>
                    VIBE INSURANCE BROKING AND ADVISORY <br />
                    SERVICE PRIVATE LIMITED
                  </h1>
                  <p class="mb-2">Point Of Sale</p>
                  <p>Training Certificate</p>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-4 pdf-reg">
                  <p>Registration No. ${data.registrationNo}</p>
                  <p>Date: ${data.date}</p>
                </div>
              </div>
              <div class="certify-content">
                This is to certify that <b>Mr./Ms. ${data.name}</b>
                [Aadharno. <b>${data.aadharNo}</b> | PAN No: <b>${data.panNo}</b>] has
                successfully completed the prescribed training on <b>${data.trainingDate}</b>
                specified for Point of Sales Person examination conducted by Vibe Insurance
                Broking and Advisory Service Pvt Ltd under the Guidelines of IRDAI
                (Ref No. IRDAI/DB1027/2023 dated 04.07.2023)
              </div>
              <br />
              <div class="pdf-txt-cntnt">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="text-center">
                    <img src="${data.principleSign}" style="width: 100px;" alt="Signature" />
                    <div class="sign-pdf">Principal officer</div>
                    <div class="off-name">${data.principalOfficer}</div>
                  </div>
                  <div class="text-center">
                    <img src="${data.techSign}" style="width: 100px;" alt="Signature" />
                    <div class="sign-pdf">Technical Head</div>
                    <div class="off-name">${data.technicalHead}</div>
                  </div>
                </div>
              </div>
              <div class="footer-pdf">${data.address}</div>
            </div>
          </div>
        </div>
        <script>
          window.onload = function() {
            window.print();
          }
        </script>
      </body>
    </html>
  `;

  printWindow.document.open();
  printWindow.document.write(contentHtml);
  printWindow.document.close();
};
